import { useDropzone } from "react-dropzone";
import { _ } from "i18n";
import DeleteIcon from "ui-kit/assets/delete/delete.svg";
import { GAME_HISTORY_ACCEPTED_FILE_TYPES, type GameHistoryPendingFile } from "./constants";
import { GameHistoryUserAvatar } from "./GameHistoryUserAvatar";

interface GameHistoryAddNoteFormProps {
	noteText: string;
	attachedFiles: GameHistoryPendingFile[];
	isSubmitting: boolean;
	userPhoto: string | null;
	onNoteTextChange: (text: string) => void;
	onSubmit: () => void;
	onFileDrop: (files: File[]) => void;
	onRemoveFile: (fileId: string) => void;
}

export function GameHistoryAddNoteForm({
	noteText,
	attachedFiles,
	isSubmitting,
	userPhoto,
	onNoteTextChange,
	onSubmit,
	onFileDrop,
	onRemoveFile,
}: GameHistoryAddNoteFormProps) {
	const { getRootProps, getInputProps, open } = useDropzone({
		onDrop: onFileDrop,
		accept: GAME_HISTORY_ACCEPTED_FILE_TYPES,
		noClick: true,
		noKeyboard: true,
	});

	return (
		<div className="discoverGameHistory-addForm" {...getRootProps()}>
			<input {...getInputProps()} />
			{attachedFiles.length > 0 && (
				<div className="discoverGameHistory-attachedFiles">
					{attachedFiles.map((f) => (
						<div key={f.id} className="discoverGameHistory-attachedFile">
							<span>{f.file.name}</span>
							<button
								type="button"
								onClick={() => onRemoveFile(f.id)}
								className="discoverGameHistory-removeFileBtn"
								aria-label={_("btn.delete")}
							>
								<img src={DeleteIcon} alt="" />
							</button>
						</div>
					))}
				</div>
			)}
			<div className="discoverGameHistory-addFormRow">
				<GameHistoryUserAvatar photo={userPhoto} className="discoverGameHistory-userAvatar" />
				<input
					type="text"
					className="discoverGameHistory-input"
					placeholder={_("discover.gameDetail.history.placeholder")}
					value={noteText}
					onChange={(e) => onNoteTextChange(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === "Enter" && !e.shiftKey) {
							e.preventDefault();
							onSubmit();
						}
					}}
				/>
				<button type="button" className="discoverGameHistory-attachBtn" onClick={open}>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M14 8.667l-5.293 5.293a3.333 3.333 0 01-4.714-4.713L9.64 3.6a2.222 2.222 0 013.143 3.143L7.133 12.4a1.111 1.111 0 01-1.572-1.572l5.293-5.293" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				</button>
				<button
					type="button"
					className="discoverGameHistory-submitBtn"
					onClick={onSubmit}
					disabled={(!noteText.trim() && attachedFiles.length === 0) || isSubmitting}
				>
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M14.667 1.333L7.333 8.667M14.667 1.333l-4.667 13.334-3-6.667-6.667-3 13.334-4.667z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				</button>
			</div>
		</div>
	);
}
